import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/core/auth.interceptor';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  trophyOutline,
  sparklesOutline,
  libraryOutline,
  documentTextOutline,
  rocketOutline,
  shieldCheckmarkOutline,
  chevronDown,
  keyOutline,
  closeCircleOutline,
  closeOutline,
  eyeOutline,
  eyeOffOutline,
  fingerPrintOutline,
  pricetagOutline,
  logOutOutline,
} from 'ionicons/icons';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

// Register all icons BEFORE app bootstraps to prevent console loading errors
addIcons({
  trophyOutline,
  sparklesOutline,
  libraryOutline,
  documentTextOutline,
  rocketOutline,
  shieldCheckmarkOutline,
  chevronDown,
  keyOutline,
  closeCircleOutline,
  closeOutline,
  eyeOutline,
  eyeOffOutline,
  fingerPrintOutline,
  pricetagOutline,
  logOutOutline,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideHttpClient(withInterceptors([authInterceptor])),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
  ],
});
